import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CityDropdownForTrip, CommonInput, CommonTextarea, CrossButton, CustomSelect } from 'components'
import { errorSchema, utils } from 'helper';
import { City, State } from "country-state-city";
import Dropdown from 'components/common/Customdropdown/Dropdown';
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import debounce from 'lodash.debounce';
import toast, { Toaster } from 'react-hot-toast';
import { createConsignor, getAllConsignorgGroup, getConsignorListData, globleGstInformation } from '_services/accountsServices/consignorServices';
import { AddButton } from 'components/common/CommonButton';
import { constant } from 'constants/constant';
import { createVenders } from '_services/accountsServices/vendorsServices';
import { createFuelStation } from '_services/accountsServices/fuelStationServices';
import { getStatesData, handleKeyDown } from '_services';
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import AddLocationModal from 'modals/AddLocationModal';
import FirmImg from '../../assets/img/firm.png';
import { getFirm, getUserFirm } from '_services/accountsServices/firmServices';
import { Link } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';
import GstDetailModal from 'modals/GstDetailModal';

const getFormattedDate = (is_date = '') => {
    const today = is_date ? new Date(is_date) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    contact_no: '',
    opening_balance: '',
    pay_type: 2,
    as_of_date: '',
    address_line1: '',
    state: {},
    city: {},
    pincode: '',
    email_id: '',
    alt_contact_no: '',
    gst_no: '',
    gst_treatment_id: {},
    gst_state: {},
    notes: '',
    firm_id: {},
}

export default function AddEditFuelStation(props) {
    let { isOpen, onClose, isPreviousModal, showingPrefield, callBackFuel, hideAddNewOption = true, branchFirmId, setVenderSelection } = props;

    const { masterData, cities, states, setStates, youtubeVideos, setYoutubeVideos } = useContext(UserContext)

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [stateValue, setStateValue] = useState({});
    const [openLoction, setOpenLoction] = useState(false)
    const [activeTab, setActiveTab] = useState(1);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [firmDataList, setFirmDataList] = useState([]);

    const [showSelectListModal, setShowSelectListModal] = useState(false);
    const [isActionCreate, setIsActionCreate] = useState(true);
    const [gstInformationLoading, setGstInformationLoading] = useState(false);

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, value: c.name, label: c.name }))

            return {

                items: [...list],

                total: res?.data?.total_record,
            };

        } else {
            toast.error(res?.responseMessage);
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === "gst_no") {
            let gstCode = parseInt(value.slice(0, 2), 10);
            stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createVendersSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async (shouldCloseModal = true) => {
        try {
            if (isOpen?._id) {
                let object = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                    contact_no: formValue?.contact_no != null ? formValue?.contact_no : '',
                    pincode: formValue?.pincode != null ? formValue?.pincode : '',
                    alt_contact_no: formValue?.alt_contact_no != null ? formValue?.alt_contact_no : '',
                    gst_treatment_id: formValue?.gst_treatment_id?.value,
                }
                const res = await createFuelStation(object);
                if (res?.responseCode === 200) {
                    setFormValue({});
                    setLoading(false);
                    toast.success('Fuel Station Created Successfully');
                    if (shouldCloseModal) {
                        onClose();
                        callBackFuel(res?.data?.fuelstation?._id)
                        let createObj = {
                            label: res?.data?.fuelstation?.name,
                            value: res?.data?.fuelstation._id,
                            gst_state: res?.data?.fuelstation.gst_state,
                        }
                        setVenderSelection(createObj)
                    } else {
                        setActiveTab(1); // Reset tab to the first tab
                    }
                    showingPrefield(true);
                    isPreviousModal(true);

                } else {
                    setLoading(false);
                }
            } else {
                let object = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                    gst_treatment_id: formValue?.gst_treatment_id?.value,
                }
                const res = await createFuelStation(object);
                if (res?.responseCode === 200) {
                    setLoading(false);
                    toast.success('Fuel Station Created Successfully');
                    if (shouldCloseModal) {
                        setFormValue({});
                        onClose();
                        callBackFuel(res?.data?.fuelstation?._id)
                        let createObj = {
                            label: res?.data?.fuelstation?.name,
                            value: res?.data?.fuelstation._id,
                            gst_state: res?.data?.fuelstation.gst_state,
                        }
                        setVenderSelection(createObj)

                    } else {
                        setActiveTab(1); // Reset tab to the first tab
                    }
                    showingPrefield(true);
                    isPreviousModal(true);

                } else {
                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createVendersSchema);
        if (activeTab === 3) {
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(true); // Pass true to close the modal
                setFormError("");
            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        } else {
            if (activeTab == 2) {
                if (utils?.isObjectKeyEmpty(validationResult)) {
                    setActiveTab(activeTab + 1);
                }
            } else {
                if (utils?.isObjectKeyEmpty(validationResult)) {
                    setActiveTab(activeTab + 1);
                }
            }
            setFormError(validationResult);
        }
    };

    const handleResetFormAndSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true); // Disable the button immediately
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createVendersSchema);
        if (activeTab === 3) {
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(false); // Pass false to keep the modal open and reset the form
                setFormValue((prevData) => ({
                    ...prevData,
                    company_id: StorageService.getCompanyId(),
                    name: '',
                    contact_no: '',
                    opening_balance: '',
                    pay_type: 2,
                    as_of_date: getFormattedDate(),
                    address_line1: '',
                    state: {},
                    city: {},
                    pincode: '',
                    email_id: '',
                    alt_contact_no: '',
                    gst_no: '',
                    notes: ''
                }))
                setFormError("");

            } else {
                setFormError(validationResult);
                setLoading(false);
                setIsButtonDisabled(false); // Re-enable the button if moving to the next tab
            }
        } else {
            setActiveTab(activeTab + 1);
            setFormError(validationResult);
            setIsButtonDisabled(false); // Re-enable the button if moving to the next tab
        }
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createVendersSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }

    };

    // edit consignor group

    useEffect(() => {
        if (!isOpen?._id) {
            if (masterData?.gst_type_list?.length > 0 && states?.length > 0) {
                setFormValue((s) => ({
                    ...s,
                    company_id: StorageService.getCompanyId(),
                    as_of_date: utils?.getTodayDate(),
                    gst_state: formValue?.state?.label ? {
                        label: formValue?.state?.label ? formValue?.state?.label : '',
                        value: formValue?.state?.value ? formValue?.state?.value : '',
                    } : {},
                    gst_treatment_id: isActionCreate ? (masterData?.gst_type_list?.length > 0 ? masterData?.gst_type_list?.map((el) => {
                        return {
                            label: el?.name,
                            value: el?.id
                        }
                    })[0] : { value: 1, label: "Unregistered Business" }) : masterData?.gst_type_list?.map((el) => {
                        return {
                            label: el?.name,
                            value: el?.id
                        }
                    })[1],
                    // gst_treatment_id: masterData?.gst_type_list?.map((el) => {
                    //     return {
                    //         label: el?.name,
                    //         value: el?.id
                    //     }
                    // })[0],
                }));
            }
        }
    }, [masterData?.gst_type_list?.length > 0, states?.length > 0, StorageService.getCompanyId(), isOpen, formValue?.state]);

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        if (value > activeTab) {
            const validationResult = await utils.checkFormError(formValue, errorSchema.createVendersSchema);
            if (validationResult === true) {
                setActiveTab(value);
            } else {
                setFormError(validationResult);
            }
        } else {
            setActiveTab(value);
        }
    };

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode ? countryCode : "IN",
                stateCode: stateCode ? stateCode : "",
            };
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                if (countryCode && stateCode) {
                    setStateValue(response?.data[0]);
                    return response?.data[0];
                } else {
                    const optionsState = response?.data?.map((d) => {
                        return {
                            ...d,
                            label: d?.name,
                            value: d?.name
                        };
                    });

                    StorageService.setStates(JSON.stringify([...optionsState]))
                    setStates([...optionsState]);
                }
            } else {
                if (response) {
                    toast.error(response?.responseMessage)
                }
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    };

    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.name,
            value: data?.name,
            lat: String(data?.latitude),
            long: String(data?.longitude)
        })

        getStatesByApi(data?.countryCode, data?.stateCode);

        // const stateDetails = State.getStateByCodeAndCountry(
        //     data?.stateCode,
        //     data?.countryCode
        // );
        // if (stateDetails?.name && stateDetails?.isoCode) {
        //     setStateValue(stateDetails)
        // }
    }

    useEffect(() => {
        if (stateValue?.name) {
            handleOnChange("state", {
                label: stateValue?.name, value: stateValue?.name, lat: String(stateValue?.latitude),
                long: String(stateValue?.longitude)
            })
        }
    }, [stateValue])

    useEffect(() => {
        if (isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                firm_id: {
                    label: isOpen?.firm_id?.firm,
                    value: isOpen?.firm_id?._id
                },
                company_id: isOpen?.company_id,
                name: isOpen?.name,
                contact_no: isOpen?.contact_no,
                opening_balance: isOpen?.opening_balance,
                pay_type: +isOpen?.pay_type,
                as_of_date: getFormattedDate(isOpen?.as_of_date),
                address_line1: isOpen?.address_line1,
                state: isOpen?.state,
                city: isOpen?.city,
                pincode: isOpen?.pincode,
                email_id: isOpen?.email,
                alt_contact_no: isOpen?.alt_contact_no,
                gst_no: isOpen?.gst_no ? isOpen?.gst_no : '',
                gst_treatment_id: isOpen?.gst_type ? masterData?.gst_type_list?.filter((element) => (element?.id === isOpen?.gst_type)).map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0] : masterData?.gst_type_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0],
                gst_state: isOpen?.gst_state?.label ? isOpen?.gst_state : {},
                notes: isOpen?.notes,
                fuelstation_id: isOpen?._id
            }))
        }
    }, [isOpen])

    useEffect(() => {
        if (formValue?.gst_treatment_id?.value === 1) {
            setFormValue((s) => ({
                ...s,
                gst_no: ''
            }))
        }
    }, [formValue?.gst_treatment_id])

    const addNewItemHandler = (e) => {

        setOpenLoction(true)
    }


    const callBackDataMaps = async (data) => {
        handleCityChange(data, "city")
        fetchFromCity()

    }

    let gmapLocates = {
        isOpen: openLoction,
        closeModal: (e) => setOpenLoction(false),
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMaps
    };

    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                if (!isOpen?._id) {
                    if (apiData?.length === 1) {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: apiData[0]
                        }))
                    } else {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: {}
                        }))
                    }
                }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getDataFirmList();
        getStatesByApi();
    }, [])

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Fuel Station`,
        submitTitle: `Add Fuel Station`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.fuel_station,
    }

    // useEffect(() => {
    //     if (firmDataList?.length > 0 && !isOpen?._id) {
    //         let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
    //         setFormValue((s) => ({
    //             ...s,
    //             firm_id: findObject?.value ? findObject : {}
    //         }))
    //     }
    // }, [StorageService.getFirmId(), firmDataList, isOpen?._id])

    useEffect(() => {

        if (firmDataList?.length > 0 && !isOpen?._id) {
            const storageFirmId = StorageService.getFirmId();

            let findObject = firmDataList.find((el) => el?.value === storageFirmId);

            const branchFirm = branchFirmId?._id;
            let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

            setFormValue((s) => ({
                ...s,
                ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
            }));
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);

    const handleGstDetailsInformation = async (gst_data) => {
        setGstInformationLoading(true);
        try {
            let object = {
                gstin: gst_data,
            }
            const res = await globleGstInformation(object);
            if (res?.responseCode == 200) {
                const resultData = res?.data?.response[0]?.response;
                setShowSelectListModal(resultData);
                setGstInformationLoading(false);
            } else {
                setGstInformationLoading(false);
            }
        } catch (error) {
            setGstInformationLoading(false);
        }
    }

    const handleFetch = (event) => {
        event.preventDefault();
        if (formValue?.gst_no?.length === 15 && !gstInformationLoading) {
            handleGstDetailsInformation(formValue?.gst_no)
        }
    }

    const onUpdateHandler = (event) => {
        event.preventDefault();
        setFormValue((s) => ({
            ...s,
            name: showSelectListModal?.tradeName || showSelectListModal?.legalNameOfBusiness,
            address_line1: `${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.location} ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.streetName || ''}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.buildingName}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.pincode}`,
            state: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName ? { label: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName, value: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName } : {},
            city: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName ? { label: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName, value: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName } : {},
            pincode: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.pincode,
            gst_treatment_id: {
                label: "Registered Regular",
                value: 2
            },
            gst_no: showSelectListModal?.gstIdentificationNumber,
        }))
        setShowSelectListModal(false);
        setIsActionCreate(false);
    }

    let updateListProps = {
        isOpen: showSelectListModal,
        closeModal: (e) => setShowSelectListModal(false),
        onSubmit: (e) => setShowSelectListModal(false),
        modalMainClass: " _dashCommon_Modal  _mdModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: "Update By",
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        onUpdate: (e) => onUpdateHandler(e),
        onContinue: (e) => setShowSelectListModal(false),
    };

    console.log(branchFirmId)

    return (
        <>
            <div className={formValue?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
                {formValue?.firm_id?.label ?
                    <div>
                        <h5 className="offcanvas-title">{isOpen?._id ? 'Update Fuel Station' : 'Add Fuel Station'}</h5>
                        <p className='offcanvas_heading_head'>
                            <img src={FirmImg} className='firm_icon_img' /> {" "}
                            {formValue?.firm_id?.label ? formValue?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
                        </p>
                    </div>
                    :
                    <h5 className="offcanvas-title">{isOpen?._id ? 'Update Fuel Station' : 'Add Fuel Station'}</h5>
                }

                <div className="flxs_lr_cls">
                    {!isOpen?._id && (
                        <div className="youtube_Icon" onClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'fuel_station_creation', moduleAction: true }))}>
                            <button><FaYoutube size={36} /></button>
                        </div>
                    )}
                    <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black" />
                        </svg>
                    </CrossButton>
                </div>
            </div>

            <div className="offcanvas-body">
                <div className='pr_procssBx'>
                    <div className='pr_procssBx_grid'>

                        {!isOpen?._id && firmDataList?.length > 1 && <div className='singleDiv'>
                            <CustomSelect
                                options={firmDataList}
                                label="Select Firm"
                                placeholder="Select Firm"
                                name="firm_id"
                                value={formValue?.firm_id}
                                error={formError["firm_id.label"]}
                                disabled={
                                    hideAddNewOption
                                        ? false
                                        : (branchFirmId && formValue?.firm_id?.value ? true : false)
                                }
                                onSelect={(data) => onhandleSelect(data, 'firm_id')}
                            />
                        </div>}

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Fuel Station Name"
                                label="Fuel Station Name *"
                                name='name'
                                value={formValue.name}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Mobile Number"
                                label='Mobile Number'
                                name='contact_no'
                                maxLength="16"
                                value={formValue.contact_no}
                                focus={!!(typeof formError === "object" && formError?.contact_no)}
                                error={!!(typeof formError === "object") ? formError?.contact_no : ""}
                                onInput={utils.maxLengthCheck}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                        <div className='halfDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Opening Balance (₹)"
                                label="Opening Balance (₹)"
                                name='opening_balance'
                                maxLength="15"
                                onInput={maxLengthCheck}
                                value={formValue.opening_balance}
                                focus={!!(typeof formError === "object" && formError?.opening_balance)}
                                error={!!(typeof formError === "object") ? formError?.opening_balance : ""}
                                onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                        <div className='halfDiv'>
                            <CommonInput
                                type="date"
                                placeholder="As of Date * "
                                label="As of Date * "
                                name='as_of_date'
                                value={formValue.as_of_date}
                                onKeyDown={(e) => e.preventDefault()}
                                focus={!!(typeof formError === "object" && formError?.as_of_date)}
                                error={!!(typeof formError === "object") ? formError?.as_of_date : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>
                    </div>

                    <div className='checkBx_lv mt-2'>
                        {
                            constant.Receive_Pay?.map((el, ind) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <div className='_dualCheckr_bx'>
                                            <input
                                                className="form-check-input"
                                                id={+ind + "pay_type" + el?.value}
                                                type="radio"
                                                name="pay_type"
                                                checked={Number(formValue?.pay_type) === Number(el?.value)}
                                                value={formValue?.pay_type ? formValue?.pay_type : ""}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, +el?.value)
                                                }
                                            />
                                            <label htmlFor={+ind + "pay_type" + el.value} className="form-check-label" >
                                                {el.label}
                                            </label>
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                </div>

                <div className='addPr_flBx __newTabs_bx' style={{ height: 'auto' }}>
                    <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
                        {constant.addPartyTabs?.map((item, indx) => (
                            <li
                                className="nav-item"
                                role="presentation"
                                key={indx + item?.value}
                            >
                                <button
                                    className={
                                        "nav-link " + (activeTab === item?.id ? "active" : "")
                                    }
                                    type="button"
                                    aria-selected={activeTab === item?.id}
                                    onClick={(e, val) => changeActiveTab(e, item.id)}
                                >
                                    {item?.title}
                                </button>
                            </li>
                        ))}

                        {/* <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="address-tab" data-bs-toggle="tab" data-bs-target="#address-tab-pane" type="button" role="tab" aria-controls="address-tab-pane" aria-selected="true">Address</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="tax-tab" data-bs-toggle="tab" data-bs-target="#tax-tab-pane" type="button" role="tab" aria-controls="tax-tab-pane" aria-selected="false">Tax Info</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="other-tab" data-bs-toggle="tab" data-bs-target="#other-tab-pane" type="button" role="tab" aria-controls="other-tab-pane" aria-selected="false">Other Details</button>
                            </li> */}
                    </ul>

                    {activeTab === 1 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>

                                <div className='singleDiv'>
                                    <div className="h4Head">Add Address</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Address Line 1"
                                        label="Address Line 1"
                                        name='address_line1'
                                        value={formValue.address_line1}
                                        focus={!!(typeof formError === "object" && formError?.address_line1)}
                                        error={!!(typeof formError === "object") ? formError?.address_line1 : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    {/* <CustomSelect
                                        options={cities}
                                        optionShowCityState={true}
                                        onSelect={(data) => handleCityChange(data, 'city')}
                                        value={formValue?.city}
                                        placeholder="Select a city"
                                        error={formError["city.label"]}
                                        label="City"
                                    /> */}
                                    <CityDropdownForTrip
                                        key={`fromLoction`}
                                        label="City "
                                        placeholder="Select a city"
                                        fetchData={fetchFromCity}
                                        isAddButton={true}
                                        addButtonAction={(e) => addNewItemHandler(e)}
                                        pageSize={20}
                                        onChange={(data) => handleCityChange(data, "city")}

                                        selectedItem={formValue?.city}
                                        error={!!formError["city.label"]}
                                        errorMessage={
                                            formError["city.label"]
                                        }
                                        withState={false}
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="State"
                                        label="State"
                                        name='state'
                                        disabled={true}
                                        value={formValue?.state?.label}
                                        focus={!!(typeof formError === "object" && formError?.state)}
                                        error={!!(typeof formError === "object") ? formError?.state : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="PIN Code"
                                        label="PIN Code"
                                        name="pincode"
                                        maxLength={6}

                                        value={formValue.pincode}
                                        focus={!!(typeof formError === "object" && formError?.pincode)}
                                        error={!!(typeof formError === "object") ? formError?.pincode : ""}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^\d*$/.test(value)) {
                                                handleOnChange(name, value);
                                                // setPhoneError("");
                                            }
                                        }}
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <div className="h4Head">Other Contact</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Alternate Number"
                                        label="Alternate Number"
                                        name='alt_contact_no'
                                        maxLength="16"
                                        value={formValue.alt_contact_no}
                                        focus={!!(typeof formError === "object" && formError?.alt_contact_no)}
                                        error={!!(typeof formError === "object") ? formError?.alt_contact_no : ""}
                                        onInput={utils.maxLengthCheck}
                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="Email"
                                        placeholder="Email ID"
                                        label='Email ID'
                                        name='email_id'
                                        maxLength="50"
                                        onInput={utils.maxLengthCheck}
                                        value={formValue.email_id}
                                        focus={!!(typeof formError === "object" && formError?.email_id)}
                                        error={!!(typeof formError === "object") ? formError?.email_id : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>
                                <div className='singleDiv'>
                                    <CustomSelect
                                        options={masterData?.gst_type_list?.map((el) => {
                                            return {
                                                label: el?.name,
                                                value: el?.id
                                            }
                                        })}
                                        name="gst_treatment_id"
                                        flotingLabel="GST Type"
                                        value={formValue?.gst_treatment_id}
                                        error={formError["gst_treatment_id.label"]}
                                        onSelect={(data) => onhandleSelect(data, 'gst_treatment_id')}
                                        placeholder="Select GST Type"
                                    />
                                </div>

                                {
                                    (formValue?.gst_treatment_id?.value == '2' || formValue?.gst_treatment_id?.value == '3') && (
                                        <div className='singleDiv _relatePos'>
                                            <CommonInput
                                                type="text"
                                                placeholder="GST Number e.g. 09AAACH7409R1RR"
                                                label='GST Number'
                                                name='gst_no'
                                                maxLength={15}
                                                onInput={maxLengthCheck}
                                                value={formValue.gst_no}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, value.toUpperCase())
                                                }
                                                focus={!!(typeof formError === "object" && formError?.gst_no)}
                                                error={!!(typeof formError === "object") ? formError?.gst_no : ""}
                                            />
                                            <span className='_weightSpan _avPointer' onClick={(e) => handleFetch(e)}> Fetch </span>
                                        </div>
                                    )
                                }

                                <div className='singleDiv'>
                                    <CustomSelect
                                        options={states?.map((el) => {
                                            return {
                                                label: el?.name,
                                                value: el?.name
                                            }
                                        })}
                                        name="gst_state"
                                        flotingLabel="GST State"
                                        value={formValue?.gst_state}
                                        error={formError["gst_state.label"]}
                                        onSelect={(data) => onhandleSelect(data, 'gst_state')}
                                        placeholder="Select GST State"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 3 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>

                                <div className='singleDiv'>
                                    <CommonTextarea
                                        type="textarea"
                                        label="Notes "
                                        rows={5}
                                        placeholder="Notes "
                                        name='notes'
                                        maxLength="500"
                                        onInput={utils.maxLengthCheck}
                                        value={formValue.notes}
                                        focus={!!(typeof formError === "object" && formError?.notes)}
                                        error={!!(typeof formError === "object") ? formError?.notes : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            </div>

            <div className='offcanvas-footer'>
                {
                    (activeTab === 3) ? (
                        <React.Fragment>
                            <AddButton onClick={handleClick} disabled={loading} name={loading ? 'Loading...' : (isOpen?._id ? 'Update & Save' : 'Add Fuel Station')} />
                            {!isOpen?._id ? <button
                                className={isButtonDisabled ? '_addNewComm_btn_disabled' : '_addNewComm_btn'}
                                onClick={handleResetFormAndSubmit}
                                disabled={isButtonDisabled || loading}
                            >
                                Add & New
                            </button> : <></>}
                        </React.Fragment>
                    ) : (activeTab === 2 ? (
                        <AddButton onClick={handleClick} name='Continue' />
                    ) : (
                        <AddButton onClick={handleClick} disabled={!formValue?.name || !formValue?.as_of_date} name='Continue' />
                    ))
                }
            </div>
            {openLoction && <AddLocationModal {...gmapLocates} />}

            {
                (youtubeVideos?.moduleName === 'fuel_station_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }

            {showSelectListModal && <GstDetailModal {...updateListProps} />}
        </>
    )
}
